import { useMemo } from 'react'
import { PaymentType } from '@afterpay/types'
import { PaymentOption } from '../../../model'
import { usePaymentTypeSortOrder, usePclPaymentOptions, useVisiblePaymentTypes } from '../../../state'

export interface PaymentOptionsDisplayOrder {
  sectionOrder: PaymentType[]
  sortedPclOptions: PaymentOption[]
}

const byRank = (a: PaymentOption, b: PaymentOption): number => (a.rank ?? Infinity) - (b.rank ?? Infinity)

const byInterest = (a: PaymentOption, b: PaymentOption): number => parseFloat(a.interestAmount?.amount ?? '0') - parseFloat(b.interestAmount?.amount ?? '0')

export const usePaymentOptionsDisplayOrder = (paymentTypeOrder?: PaymentType[]): PaymentOptionsDisplayOrder => {
  const paymentTypeSortOrder = usePaymentTypeSortOrder()
  const visiblePaymentTypes = useVisiblePaymentTypes()
  const pclPaymentOptions = usePclPaymentOptions()

  const isPbiFirst =
    paymentTypeSortOrder.includes(PaymentType.PBI) &&
    paymentTypeSortOrder.includes(PaymentType.PCL) &&
    paymentTypeSortOrder.indexOf(PaymentType.PBI) < paymentTypeSortOrder.indexOf(PaymentType.PCL)

  const sectionOrder = useMemo(() => {
    const rankedPaymentTypes = paymentTypeOrder?.filter((type) => visiblePaymentTypes.includes(type)) ?? []
    return [...rankedPaymentTypes, ...visiblePaymentTypes.filter((type) => !rankedPaymentTypes.includes(type))]
  }, [paymentTypeOrder, visiblePaymentTypes])

  const sortedPclOptions = useMemo(() => {
    if (paymentTypeOrder !== undefined && pclPaymentOptions.some((paymentOption) => paymentOption.rank != null)) {
      return [...pclPaymentOptions].sort(byRank)
    }
    return isPbiFirst ? [...pclPaymentOptions].sort(byInterest) : pclPaymentOptions
  }, [paymentTypeOrder, pclPaymentOptions, isPbiFirst])

  return { sectionOrder, sortedPclOptions }
}
